import axios from 'axios';
import {apiServerHost} from '../../common/APIServerSettings';

const getRedirectableRequests = (callBackFunc, topicID) => {
  const params = new URLSearchParams();
  params.append("topicID", topicID);

  axios.get(apiServerHost + "/manage/topic/builder/get/redirectableRequest",{
    params : params,
  })
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  })
}

const updateResponseRedirect = (callBackFunc, responseID, requestID) => {
  const params = new URLSearchParams();
  params.append("responseID", responseID);
  params.append("requestID", requestID);

  axios.post(apiServerHost + "/manage/topic/builder/update/response/redirect",params)
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  })
}

export {getRedirectableRequests};
export {updateResponseRedirect};